module.exports = __webpack_public_path__ + "img/feel-good-stretches-dynamic-neck-stretch.eb155d77.png";